/*
 * Generic Module for handling Folder Trees for any aspect of the site (e.g. Topic folder tree, content folder tree)
 */

define(["marionette", "messaging/messenger", "modules/shared/navTree/navTreeView"], function (
  Marionette,
  Messenger,
  NavTreeView,
) {
  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "navTree";
      this.region = options.region;
      this.root = null;
      this.nameAttribute = options.nameAttribute; //what the 'name' attribute we wish to display is called
      this.namespace = options.namespace; //namespace for all triggered events
      this.selectedGroupView = null;
      this._setUpVents();
      this._setUpReqres();
    },
    show: function (rootObject, doNotExpandOnShow) {
      this.view = new NavTreeView.navTreeView({
        model: rootObject,
        name: this.nameAttribute,
        namespace: this.namespace,
      });
      this.view.on("show", function () {
        rootObject.onSynced(function () {
          //expand root node once it is synced
          if (rootObject.get("hasSubgroups") && !doNotExpandOnShow) {
            this.expand();
          }
        }, this);
      });
      this.showRegion(this.view, { loading: true });
    },
    toggleExpandCollapse: function () {
      this.view.toggleExpandCollapse();
    },
    collapse: function () {
      if (this.view) {
        this.view.collapse();
      }
    },
    _setUpReqres: function () {
      //Set up a reqres for the group so that buttons within the group can grab the group and update the view
      Messenger.reqres.setHandler(
        Messenger.getFullName("selected:group", this.namespace),
        () => this.selectedGroupView,
        this,
      );
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "_" + Messenger.getFullName("select:group", this.namespace),
        function (view) {
          Messenger.vent.trigger("_" + Messenger.getFullName("clear:selection", this.namespace));
          view.showSelect();
          this.selectedGroupView = view;
          Messenger.vent.trigger(Messenger.getFullName("select:group", this.namespace), view);
        },
        this,
      );
      //Request to "un-select" a folder in the nav tree.  Useful in the case of navigating away from
      //an item in the nav tree into another area outside of the scope of the nav tree
      Messenger.vent.on(
        Messenger.getFullName("clear:selection", this.namespace),
        function () {
          Messenger.vent.trigger("_" + Messenger.getFullName("clear:selection", this.namespace));
        },
        this,
      );
    },
  });
});
